export default class StickyJs {
  constructor (options) {
    this.wrapper = options.wrapper || document.body
    this.selector = options.selector || '',
    this.offset = options.offset || 0,
    this.breakpointToDestroy = options.breakpointToDestroy || '1199'
    this.run()
  }
  run() {
    if (this.wrapper) {
      const stickyWrapper = document.querySelector(this.wrapper)
      if (stickyWrapper) {
        const stickyBox = stickyWrapper.querySelector(this.selector)
        window.addEventListener('scroll', () => {
          let wrapperTop = stickyWrapper.getBoundingClientRect().top
          let wrapperBottom = stickyWrapper.getBoundingClientRect().bottom
          let stickyBoxBottom = stickyBox.getBoundingClientRect().bottom
          let stickyBoxTop = stickyBox.getBoundingClientRect().top
          if (this.offset > wrapperTop) {
            if(wrapperBottom <= stickyBoxBottom && stickyBoxTop < (this.offset+1)) {
              css(stickyBox, { position: 'absolute', top: 'unset', bottom: 0, left: ''})
            } else {
              css(stickyBox, { position: 'fixed', top: `${this.offset}px`, bottom: '', left: '' })
            }
          } else {
            css(stickyBox, { position: '', top: 0, left: ''})
          }
        })
      }
    }
    function css(element, properties) {
      for (var property in properties) {
        if (properties.hasOwnProperty(property)) {
          element.style[property] = properties[property];
        }
      }
    };
  }
}